import { IconWindowMaximize3 } from "../../../themes/icons/IconWindowMaximize3";
import { IconWindowMinimize3 } from "../../../themes/icons/IconWindowMinimize3";
import Conditions from "../condition/Conditions";
import styles from "./BodyViewConditions.module.scss";

function BodyViewConditions({ nodeFunction, showConditions, setShowConditions }) {
  const handleOnClick = () => {
    const _value = Boolean(showConditions);

    setShowConditions(!_value);
  };

  return (
    <div className={`${styles["global"]}`}>
      <div className={styles["header"]} role="button" onClick={handleOnClick}>
        <div id="header_logic">Function logic</div>
      </div>
      <div className={styles["icon"]}>
        {showConditions ? <IconWindowMinimize3 /> : <IconWindowMaximize3 />}
      </div>
      <div className={`${styles["body"]}`}>
        {showConditions && (
          <div className={styles["conditions"]}>
            <Conditions node={nodeFunction} main />
          </div>
        )}
      </div>
    </div>
  );
}

export default BodyViewConditions;
